<template>
  <v-tooltip top>

    <template v-slot:activator="{ on, attrs }">
      <v-btn fab x-small depressed v-bind="attrs" v-on="on">
        <v-icon color="error">{{ mdiFlag }}</v-icon>
      </v-btn>
    </template>

    <span>{{ message }}</span>
    
  </v-tooltip>
</template>

<script>
  import { mdiFlag } from '@mdi/js';

  export default {
    props: {
      warningFlag: String,
    },

    data() {
      return {
        mdiFlag,
      }
    },

    computed: {
      message() {
        switch(this.warningFlag) {
          case 'Geographic Porting':
          case 'Manual Geographic Porting':
            return 'This number has been in a "Porting" status for more than 10 working days';
          case 'Ipex Porting':
          case 'Reseller Porting':
            return 'This number has been in a "Porting" status for more than 20 working days';
          case 'Ready to Port':
            return 'This number has been in a "Ready to Port" status for more than 2 working days';
          default:
            return '';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>